













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import Camera from '@/models/DOMCamera';

@Component({})
export default class TimelineViewerYear extends Vue
{
    @Prop(Number) readonly baseYear! : number;
    @Prop(Number) readonly interval! : number;
    @Prop(Camera) readonly camera! : Camera;
    @Prop(Number) readonly yearCount! : number;

	// no Jan because that's attached to the actual year line
	readonly months = ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	readonly weeks = [", Week 2", ", Week 3", ", Week 4"];
		
	get yearOffset() : number
	{
		return this.year - this.camera.minDate;
	}
	get year() : number
	{
		return Math.floor(this.baseYear);
	}
	get startX() : number 
	{
		return (this.year - this.camera.minDate) * this.camera.yearToPixels;
	}
	get monthInterval() : number
	{
		return this.camera.yearToPixels / 12.0;
	}
	get weekInterval() : number
	{
		return this.camera.yearToPixels / 48.0;
	}
	get yearText() : string 
	{
		let year = this.year;
		if (year < 0)
		{
			return `${-year} BCE`
		}
		return year.toString();
	}
	get displayMonthLines() : boolean 
	{
		return this.yearCount < 8;
	}
	get displayMonthLabels() : boolean 
	{
		return this.year >= 0 && this.monthInterval > 65;
	}
	get attachYearToMonthLabels() : boolean 
	{
		return this.year >= 0 
			&& ((this.monthInterval > 90 && this.startX <= 0) || this.monthInterval > 150);
	}
	get displayWeekLines() : boolean
	{
		return this.monthInterval > 500;
	}
	get displayWeekLabels() : boolean
	{
		return this.year >= 0 && this.monthInterval > 1000;
	}
}
